import { StyledNav } from '@/components/styles'
import { ActiveLink } from '@/components'
import genLinkParams from '@/lib/generateLinkParams'

export default function Nav({ menu }) {
  const {text_pages: textPages } = menu
  const [specialistsHref, specialistsAs, specialistsTitle] = genLinkParams({ type: 'specialists' })
  const [contactsHref, contactsAs, contactsTitle] = genLinkParams({ type: 'contacts' })
  const [blogHref, blogAs, blogTitle] = genLinkParams({ type: 'blog' })
  const [servicesHref, servicesAs, servicesTitle] = genLinkParams({ type: 'services' })

  const sortedPages = sortTextPages(textPages)

  return (
    <StyledNav>
      <StyledNav.List>
        <StyledNav.Item>
          <ActiveLink href={servicesHref} as={servicesAs} addHrefActive={true}  activeAs={'a'}>
            <StyledNav.Link>{servicesTitle}</StyledNav.Link>
          </ActiveLink>
        </StyledNav.Item>
         <StyledNav.Item>
          <ActiveLink href={specialistsHref} as={specialistsAs} addHrefActive={true} activeAs={'a'}>
            <StyledNav.Link>{specialistsTitle}</StyledNav.Link>
          </ActiveLink>
        </StyledNav.Item>
        {Object.keys(sortedPages).length > 0 && (
          <StyledNav.Item>
            <ActiveLink href={sortedPages.parent.href} as={sortedPages.parent.as}>
              <StyledNav.Link>{sortedPages.parent.title}</StyledNav.Link>
            </ActiveLink>
          </StyledNav.Item>
        )}

        <StyledNav.Item>
          <ActiveLink href={blogHref} as={blogAs} addHrefActive={true} activeAs={'a'}>
            <StyledNav.Link>{blogTitle}</StyledNav.Link>
          </ActiveLink>
        </StyledNav.Item>

        <StyledNav.Item>
          <ActiveLink href={contactsHref} as={contactsAs}>
            <StyledNav.Link>{contactsTitle}</StyledNav.Link>
          </ActiveLink>
        </StyledNav.Item>
      </StyledNav.List>
    </StyledNav>
  )
}

function sortTextPages(pages) {
  let parent = null
  let children = []

  pages.forEach(page => {
    const { is_main_for_menu: isMain, slug } = page
    const [href, as] = genLinkParams({ type: 'text-page', slug })

    if (isMain) {
      parent = { ...page, href, as }
    } else {
      children.push({ ...page, href, as })
    }
  })

  return parent
    ? {
        parent,
        children,
      }
    : {}
}
